export default {
  products: (state) => state.products,
  new_products: (state) => state.new_products,
  next_products_url: (state) => state.next_products_url,
  next_products_url_search: (state) => state.next_products_url_search,
  errors: (state) => state.errors,
  error_msg: (state) => state.error_msg,
  success: (state) => state.success,
};
